import { getKeys } from './getKeys'

export const shiftPasswordsTranslations = {
  ACCESS_DURATION: 'Access duration',
  ACCESS_DURATION_DESC:
    'Set how long before staff must re-enter the shift password. We recommend keeping this short (e.g. 2 hours for a 6-hour shift).',
  ACCESS_DURATION_HOURS: 'Access duration (hours)',
  ACTIONS: 'Actions',
  ADD_PASSWORD: 'Add password',
  ADDING_NEW_PASSWORD: 'Adding new password',
  ARE_YOU_SURE_CONTINUE: 'Are you sure you want to continue?',
  CANCEL: 'Cancel',
  CHANGE_PASSWORD: 'Change password',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_PASSWORD_DESC: 'Enter the same password again to confirm.',
  DELETE: 'Delete',
  DELETE_PASSWORD_CONFIRM: `You're about to delete this shift password.`,
  DELETING_PASSWORD: 'Deleting password',
  END_TIME: 'End time',
  GO_TO_SETTINGS: 'Go to Settings',
  HOUR: 'hour',
  HOURS: 'hours',
  MANAGE: 'Manage',
  NO_PASSWORD_YET: 'No password yet',
  PASSWORD: 'Password',
  PASSWORD_ADDED: 'Password added!',
  PASSWORD_DELETED: 'Password deleted!',
  PASSWORD_DELETE_FAILED: `Couldn't delete password. Please try again.`,
  PASSWORD_DESC: 'Enter a password for this shift.',
  PASSWORD_UPDATED: 'Password updated!',
  SHIFT_PASSWORD: 'Shift password',
  SHIFT_PASSWORDS: 'Shift Passwords',
  SHIFT_PASSWORDS_DISABLED_DESC:
    'Turn on shift password protection in Settings to start adding passwords.',
  SHIFT_PASSWORDS_DISABLED_TITLE: 'Shift passwords are turned off',
  SHIFT_PASSWORDS_SUBTITLE:
    'Extra password that adds another layer of security, protecting app data and stopping off-duty staff from signing in.',
  START_END_DESC:
    'Set when staff can start and stop signing in. Set it slightly before the shift for early arrivals and slightly after it ends to allow staff to finish up.',
  START_END_TIME: 'Start and end time',
  START_TIME: 'Start time',
  TITLE: 'Title',
  TITLE_DESC:
    'Describe what this shift password is used for (e.g. "Morning shift").'
}

export const shiftPasswordsConstants = getKeys(shiftPasswordsTranslations)
